const forms = Array.from(document.querySelectorAll('.umbraco-forms-form form'));

forms.forEach(x => {
    x.addEventListener('submit', y => {

        // The original <select> fields are kept in place so validation will continue
        // to work. They are removed just as the form is submitted in order to
        // avoid fields with multiple values (since our custom dropdown implementation
        // duplicates the dropdown fields).
        const selects = Array.from(x.querySelectorAll('.umbraco-forms-field.dropdown select'));
        selects.forEach(z => {
            z.parentElement.removeChild(z);
        });

        // The displayed value is not what we want to send to the server.
        // Set the input field to the true underlying value that should be
        // sent to the server.
        const fields = Array.from(x.querySelectorAll('.umbraco-forms-field.dropdown'));
        fields.forEach(z => {
            const trueValue = z.querySelector('input[type=hidden]').value;
            z.querySelector('input[type=text]').value = trueValue;
        });

    });
});
